import { render } from "./app-checkbox.vue?vue&type=template&id=ef9ad89a"
import script from "./app-checkbox.ts?vue&type=script&lang=js&external"
export * from "./app-checkbox.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__